<div class="flex-center-between gap-050">

  @if (copy) {
    <button style="color: #CB2A2F" nz-button nzType="text" nzShape="circle" nzSize="default"
            (click)="onButtonClick('copy', $event)">
      <app-st-icon [bold]="true" name="file_copy_off"></app-st-icon>
    </button>
  }

  @if (file) {
    <button nz-button nzType="text" nzShape="circle" nzSize="default"
            (click)="onButtonClick('task', $event)">
      <app-st-icon [bold]="true" name="task"></app-st-icon>
    </button>
  }

  @if (message) {
    <button nz-button nzType="text" nzShape="circle" nzSize="default"
            (click)="onButtonClick('message', $event)">
      <app-st-icon style="position: absolute; top: 16px; left: 7px;" [bold]="true" name="chat_bubble"></app-st-icon>
      <nz-badge class="blue" nzStandalone [nzDot]="messageUnread" [nzOffset]="[3, -6.5]"></nz-badge>
    </button>
  }

  @if (drawer) {
    <button nz-button nzType="text" nzShape="circle" nzSize="default"
            (click)="onButtonClick('drawer', $event)">
      <app-st-icon [bold]="true"
                   [style.line-height]="isDoc ? 2.5 : null"
                   [name]="isDoc ? 'visibility' : 'right_panel_open'"></app-st-icon>
    </button>
  }

  @if (options) {
    <button nz-button nzType="text" nzShape="circle" nzSize="default" nz-dropdown
            (click)="$event.stopPropagation()"
            [nzDropdownMenu]="actionMenu" nzTrigger="click">
      <app-st-icon [bold]="true" name="more_vert"></app-st-icon>
    </button>
  }

  <nz-dropdown-menu #actionMenu="nzDropdownMenu">
    <ul nz-menu>
      <li nz-menu-item (click)="onButtonClick('delete', $event)">
        <button class="flex-center gap-100"
                nz-button nzType="text" nzShape="circle" nzSize="default">
          <app-st-icon name="delete" [bold]="true"></app-st-icon>
          <span class="text-label-14 text-dark">Eliminar</span>
        </button>
      </li>
    </ul>
  </nz-dropdown-menu>

  @if (select) {
    <nz-select style="height: 32px;width: 256px">
      @for (op of selectList; track op) {
        <nz-option [nzValue]="op" [nzLabel]="op"></nz-option>
      }
    </nz-select>
  }

</div>
